import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {EquipmentCardEnums, EquipmentCardInterfaces, EquipmentEnums} from '@namespaces/equipment.namespace';
import {StatusChangeService} from '../services/status-change.service';
import {EquipmentStatusesProvider} from '@providers/equipment-statuses/equipment-statuses.provider';
import {EquipmentControlService} from '../services/equipment-control.service';
import {RoutesStorage} from '@helpers/routes.helper';
import {UserNamespace} from '@namespaces/user.namespace';
import {environment} from '@environments/environment';
import {CardApiService} from '@modules/equipment-card/services/card.api.service';
import {AjaxDownloadService} from '@components/ajax-download-noty/ajax-download.service';
import {EventsService} from '@services/events.service';

@Component({
    selector: 'app-apparatus-view',
    templateUrl: './apparatus-view.component.html',
    providers: [
        /**
         * Используется в StatusChangeFormModule
         */
        {provide: 'StatusChangeService', useClass: StatusChangeService},
        {provide: 'StatusProvider', useClass: EquipmentStatusesProvider},
    ]
})
export class ApparatusViewComponent implements OnInit {
    id: number;

    apparatus: EquipmentCardInterfaces.Card.ItemView;

    public statuses = EquipmentCardEnums.EquipmentStatus;
    public types = EquipmentEnums.Type;
    public permissions = UserNamespace.Permission;

    public listUrl = RoutesStorage.Equipment.list;
    public editUrl;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private controlService: EquipmentControlService,
        private cardApi: CardApiService,
        private ajaxDownloadService: AjaxDownloadService,
        private eventsService: EventsService,
    ) {}

    get requestCalibrationLabel() {
        return `
            Создать заявку на
            ${this.apparatus.apparatus.verification_status === EquipmentEnums.VerificationStatus.ongoing ? 'поверку' : 'калибровку'}
            `;
    }

    ngOnInit() {
        const { apparatus } = this.route.snapshot.data;

        if (apparatus) {
            this.apparatus = apparatus;
            this.id = +this.apparatus.id;
            this.editUrl = RoutesStorage.Equipment.edit(this.id);
        }
    }

    onStatusSave(status: number) {
        this.apparatus = {
            ...this.apparatus,
            status: +status,
        };
    }

    showRequestCalibrationDialog() {
        this.controlService.showCalibrationRequestDialog$.next();
    }

    openEdit(fragment: string = null) {
        this.router.navigate([this.editUrl], {fragment: fragment});
    }

    generateCardDocument() {
        this.cardApi.post({
            url: this.cardApi.validateCardDocumentUrl,
            dataBody: {
                ids: [this.id],
            }
        }).subscribe(() => {
            this.ajaxDownloadService.do({
                url: this.cardApi.generateCardDocumentUrl,
                taskName: 'Учетная карточка',
                method: 'post',
                data: {
                    ids: [this.id],
                }
            });
        }, (errors: string[]) => {
            let message = 'Возникла ошибка при формировании учетной карточки';

            if (errors && errors.length) {
                message = errors.join('<br>');
            }

            this.eventsService.showNoty({
                type: 'warning',
                content: message,
                controls: [
                    {
                        title: 'Сообщить об ошибке',
                        href: environment.technicalSupportUrl
                    }
                ]
            });
        });
    }
}
